import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function I() {
    const { useLang, Link, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('camp');
    const cards: any = [
        {
            img: '/responsive/picture/camp/9_1.jpg',
            title: t('secI_card1_title'),
            desc: t('secI_card1_desc'),
        },
        {
            img: '/responsive/picture/camp/9_2.jpg',
            title: t('secI_card2_title'),
            desc: t('secI_card2_desc'),
        },
        {
            img: '/responsive/picture/camp/9_3.jpg',
            title: t('secI_card3_title'),
            desc: t('secI_card3_desc'),
        },
        {
            img: '/responsive/picture/camp/9_4.jpg',
            title: t('secI_card4_title'),
            desc: t('secI_card4_desc'),
        },
        {
            img: '/responsive/picture/camp/9_5.jpg',
            title: t('secI_card5_title'),
            desc: t('secI_card5_desc'),
        },
        {
            img: '/responsive/picture/camp/9_6.jpg',
            title: t('secI_card6_title'),
            desc: t('secI_card6_desc'),
        },
    ];
    return (
        <div id="camp-I" className={`camp-I camp-box ${css['camp-I']}`}>
            <h2 className="title">{t('secI_title')}</h2>
            <p className="desc">{t('secI_desc')}</p>
            <Swiper
                className="cards"
                modules={[Scrollbar, Navigation]}
                spaceBetween={20}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation={true}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`card item-${k + 1}`} key={k}>
                        <div className="card-img">
                            <EFPicture src={card?.img} alt={card?.title} />
                        </div>
                        <h3 className="card-title">{card?.title}</h3>
                        <p className="card-desc">{card.desc}</p>
                    </SwiperSlide>
                ))}
            </Swiper>
            <p className="memo desc">{t('secI_memo')}</p>
        </div>
    );
}
